import styled from 'styled-components';

import { Spaces, Colors } from '~/styles/Metrics';

export const Container = styled.p`
  margin: ${Spaces.BaseMargin} 0;
  padding: 0 ${Spaces.BasePadding};
  color: ${Colors.Text};
`;
